<script>
import SecondaryNavBar from '../components/SecondaryNavBar.vue';

export default {
  name: 'SecondaryLayout',
  components: {
    SecondaryNavBar,
  },
};
</script>

<template>
  <div class="secondary-layout">
    <SecondaryNavBar :hide-breadcrumb="$route.name === 'article-viewer'" />
    <div class="secondary-layout-content">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.secondary-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.secondary-layout-content {
  flex: 1;
  overflow: auto;
}
</style>
